import React from 'react';

import { ReactComponent as TrashIcon } from '@pkg/assets/icons/trash.svg';

import { TrashButtonWrapper } from './styles';

interface TrashProps {
    onClick(): void;
}

export const TrashButton = ({ onClick }: TrashProps) => {
    return (
        <TrashButtonWrapper onClick={onClick}>
            <TrashIcon />
        </TrashButtonWrapper>
    );
};
